import React, { Component } from 'react'
import $ from 'jquery'
import axios from 'axios';
import '../../../static/css/popup.css';

import closeV2 from '../../../static/image/v2/popup/closeV2.png'
import shopRemoveBtn from '../../../static/image/v2/shop/shopRemoveBtn.png'
import shopAddBtn from '../../../static/image/v2/shop/shopAddBtn.png'
import {closePopup, getValue} from "../../../static/js/Common2";
import {dongNameChange} from "../../../static/js/DongVal";
import { BACK_OFFICE_API } from 'constants/apiUrls';

class ShopInfo4PopupV2 extends Component {
  componentDidMount() {
    function selectOut0() {
      document.querySelector('body').addEventListener('click', function(e) {
        if(e.target.className !== 'paySelect selectText') {
          $(`#paySelect`).removeClass('active')
        }
      })
    }

    selectOut0()

    function selectOut1() {
      document.querySelector('body').addEventListener('click', function(e) {
        if(e.target.className !== 'selectText lengthText') {
          $(`.lengthSelect`).removeClass('active')
        }
      })
    }

    selectOut1()
  }

  dongAdd = (e) => {
    let propsDongList = this.props.dongList
    let dong1 = ''

    for(var i = 0; propsDongList.length > i; i++) {
      dong1 += `<li class='dongLi' data-id=${ propsDongList[i].addrMgtId } data-type='0' data-name=${ propsDongList[i].admstrDong } >${ propsDongList[i].admstrDong }</li>`
    }

    let dataset = e.target.dataset
    let index = dataset.index
    var zIndex = 200 - Number(index)
    dataset.index = 1 + Number(index)
    var div = document.createElement('div')
    div.innerHTML = `<div class='popupSelect'>` +
    `<div class='selectText' data-name='------선택-----' data-id='0' data-idx='0' data-modi='0'>------선택-----</div>` +
    `<ul class='selectOptionList'>` + dong1 + `</ul></div>` +
    `<div><input class='dongCostInput' />원</div>` +
    `<button type='button' class='deliveryRemoveBtn'><img src=${ shopRemoveBtn } alt='삭제' /></button>`
    
    div.setAttribute('class', 'popupFlexBox popupFlexBox1 dongCostList')
    div.querySelector('.popupSelect').style.zIndex = zIndex
    $('.dongCostListBox').append(div)

    div.querySelector('.deliveryRemoveBtn').addEventListener('click', () => {
      div.remove()
    })

    div.querySelector('.dongCostInput').addEventListener('change', (e) => {
      var n = e.target.value

      if(n < 0) {
        alert('0원 이상 입력가능합니다.')
        e.target.value = 0
      }{/**  else {
        n = Math.floor(n/100) * 100
        e.target.value = n
      }*/}
    })

    div.querySelector('.selectText').addEventListener('click', (e) => {
      e.target.parentElement.className = 'popupSelect active'
    })

    var dongLi = div.querySelectorAll('.dongLi')

    var dongList = []

    $('.dongCostList').each(function() {
      var idx = $(this).find('.selectText').attr('data-idx')
      if(Number(idx) !== 0) {
        dongList.push(idx)
      }
    })

    dongLi.forEach((target) => target.addEventListener('click', (e) => {
      var dataIdx = e.target.dataset.id
      var dataName = e.target.dataset.name
      var result = true

      for(var i = 0; dongList.length > i; i++) {
        if(Number(dongList[i]) === Number(dataIdx)) {
          result = false
        }
      }

      if(result) {
        var select = e.target.parentElement.parentElement.querySelector('.selectText')
        select.dataset.idx = dataIdx
        select.dataset.name = dataName
        select.innerText = dataName
        e.target.parentElement.parentElement.className = 'popupSelect'
      } else {
        alert('이미 선택된 동은 선택할 수 없습니다.')
      }
    }))
  }

  dongSelectActive = (e) => {
    e.target.parentElement.className = 'popupSelect active'
  }

  dongSelectOption = (e) => {
    let dataset = e.target.dataset
    let id = dataset.id
    let name = dataset.name
    let dongList = []
    let result = true

    $('.dongCostList').each(function() {
      var idx = $(this).find('.selectText').attr('data-idx')
      if(Number(idx) !== 0) {
        dongList.push(idx)
      }
    })

    for(var i = 0; dongList.length > i; i++) {
      if(Number(dongList[i]) === Number(id)) {
        result = false
      }
    }

    if(result) {
      var select = e.target.parentElement.parentElement.querySelector('.selectText')
      select.dataset.idx = id
      select.dataset.name = name
      select.innerText = name
      e.target.parentElement.parentElement.className = 'popupSelect'
    } else {
      alert('이미 선택된 동은 선택할 수 없습니다.')
    }
  }

  dongCostRemove = (e) => {
    let dataset = e.target.dataset
    let id = dataset.id
    let shopId = Number(this.props.shopId)

    axios.delete(`${ BACK_OFFICE_API }/extra/dong`, {
      params: {
        shopId : Number(shopId),
        addrMgtId : String(id)
      }
    }).then(function() {
      e.target.parentElement.parentElement.remove()
    })
  }

  selectDong = (e) => {
    let dataset = e.target.dataset
    let dataModi = Number(dataset.modi)
    let dataName = dataset.name
    let dataCost = Number(dataset.cost)

    let dongList = this.props.dongList
    let dongCostList = this.props.dongCostList
    let dong = []

    console.log(dongList);

    $('.popupSelect').removeClass('active')
    $('#paySelect .selectText').text(dataName)
    $('.dongListBox').empty()
    $('#dongCost').val(dataCost)
    for(var i = 0; dongList.length > i; i++) {
      var result = true

      for(var j = 0; dongCostList.length > j; j++) {
        if(dongList[i] === dongCostList[j].admstrName) {
          result = false
        }
      }

      if(result) {
        dong.push({
          id: 0,
          idx: dongList[i],
          name: dongNameChange(dongList[i]),
          modi: 0
        })
      }
    }

    if(Number(dataModi) === 1) {
      for(var k = 0; dongCostList.length > k; k++) {
        if(dataCost === dongCostList[k].extraCost) {
          dong.push({
            id: dongCostList[k].dongId,
            idx: dongCostList[k].addrMgtId,
            name: dongCostList[k].admstrDong,
            modi: 1
          })
        }
      }
    }

    console.log(dong);

    for(var n = 0; dong.length > n; n++) {
      var label = document.createElement('label')
      label.innerHTML = `${ dong[n].name }`
      label.setAttribute('data-idx', `${ dong[n].idx }`)
      //label.setAttribute('data-id', `${ dong[n].id }`)
      if(dong[n].modi === 1) {
        label.setAttribute('class', 'dongLabel label active')
        label.setAttribute('data-type', 1)
        label.setAttribute('data-modi', 1)
        label.setAttribute('data-id', dong[n].id)
      } else {
        label.setAttribute('class', 'dongLabel label')
        label.setAttribute('data-type', 0)
        label.setAttribute('data-modi', 0)
      }

      $('.dongListBox').append(label)
    }
  }

  constructor() {
    super()

    this.state={
      dongList: []
    }
  }

  render() {
    let shopId = Number($(".shopSelectText").attr("data-id"))
    let propsTimeList = this.props.timeList
    let output1 = this.props.output1

    //셀렉트 활성화
    $('.selectText').off('click').on('click', function() {
      if($(this).parent().hasClass('active') === true) {
        $(this).parent().removeClass('active')
      } else {
        $(this).parent().addClass('active')
      }
    })

    for(var i = 0; propsTimeList.length > i; i++) {
      $(`.timeLabel${ propsTimeList[i].dowTpcd }`).addClass('active')
      $(`.timeLabel${ propsTimeList[i].dowTpcd }`).attr('data-type', '1')
      $(`.timeLabel${ propsTimeList[i].dowTpcd }`).attr('data-modi', '1')
      $(`.timeLabel${ propsTimeList[i].dowTpcd }`).attr('data-idx', propsTimeList[i].id)

      var startDate = propsTimeList[i].extraStartTm.split(':')
      var endDate = propsTimeList[i].extraEndTm.split(':')

      $('#hours1').val(startDate[0]);
      document.getElementById("hours1").setAttribute("data-value", startDate[0]);
      $('#minutes1').val(startDate[1]);
      document.getElementById("minutes1").setAttribute("data-value", startDate[1]);
      $('#hours2').val(endDate[0]);
      document.getElementById("hours2").setAttribute("data-value", endDate[0]);
      $('#minutes2').val(endDate[1]);
      document.getElementById("minutes2").setAttribute("data-value", endDate[1]);
      $('#timeCost').val(propsTimeList[i].extraCost);

      $('.timeAllLabel').addClass('active')
      $('.timeAllLabel').attr('data-type', '1')
      $('.timeAllLabel').text('전체 해제')
    }

    // 행정동 선택
    $(document).off('click').on('click', '.label', function() {
      if($(this).attr('data-type') === '0') {
        $(this).addClass('active')
        $(this).attr('data-type', '1')
      } else {
        $(this).removeClass('active')
        $(this).attr('data-type', '0')
      }
      
      if($(this).hasClass('timeLabel') === true) {
        $('.timeLabel').each(function() {
          var dataType = $(this).attr('data-type')

          if(Number(dataType) === 1) {
            $('.timeAllLabel').addClass('active')
            $('.timeAllLabel').attr('data-type', '1')
            $('.timeAllLabel').text('전체 해제')
            return false
          } else {
            $('.timeAllLabel').removeClass('active')
            $('.timeAllLabel').text('전체 선택')
          }
        })
      } else if($(this).hasClass('timeAllLabel') === true) {
        var dataType = $(this).attr('data-type')
        if(Number(dataType) === 1) {
          $('.timeLabel').addClass('active')
          $('.timeLabel').attr('data-type', '1')
          $('.timeAllLabel').addClass('active')
          $('.timeAllLabel').attr('data-type', '1')
          $('.timeAllLabel').text('전체 해제')
        } else {
          $('.timeLabel').removeClass('active')
          $('.timeLabel').attr('data-type', '0')
          $('.timeAllLabel').removeClass('active')
          $('.timeAllLabel').attr('data-type', '0')
          $('.timeAllLabel').text('전체 선택')
        }
      }
    })

    // 시간 제한
    $('.hours').off('keyup').on('keyup', function() {
      if($(this).val() > 23) {
        alert('23시 이상은 설정할 수 없습니다.')
        $(this).val(23)
      } else if($(this).val() < 0) {
        alert('0시 이하는 설정할 수 없습니다.')
        $(this).val(0)
      }
    })
    $('.minutes').off('keyup').on('keyup', function() {
      if($(this).val() > 59) {
        alert('59분 이상은 설정할 수 없습니다.')
        $(this).val(59)
      } else if($(this).val() < 0) {
        alert('0분 이하는 설정할 수 없습니다.')
        $(this).val(0)
      }
    })

    $('.lengthCostPopupBtn').off('click').on('click', async function() {
      var testResult = true
      var deliveryList = []

      $('.lengthCostBox').each(function() {
        var id = $(this).find('.selectText').attr('data-id')
        var modi = $(this).find('.selectText').attr('data-modi')
        var lengthCost = $(this).find('.lengthCost').val()

        if(Number(id) === 0) {
          alert('거리를 선택해주세요')
          testResult = false
          return false
        }
        if(lengthCost === '') {
          alert('추가 배달비를 입력해주세요')
          testResult = false
          return false
        }

        if(Number(modi) === 0) {
          deliveryList.push({
            shopId: shopId,
            stdDist: id,
            extraCost: lengthCost
          })
        }
      })

      if (testResult === true && deliveryList.length > 0) {
        /*const deleteRequests = propsDongCostList.map(async (item) => {
          await axios.delete(`${BACK_OFFICE_API}/extra/dong`, {
            params: {
              shopId: item.shopId,
              id: item.dongId,
            },
          });
        });

        // 모든 삭제 요청이 완료될 때까지 기다림
        await Promise.all(deleteRequests);*/

        // 이후 추가 요청 실행
        const postRequests = deliveryList.map((item, index) => {
          return new Promise((resolve) => {
            setTimeout(async () => {
              await axios.post(`${BACK_OFFICE_API}/extra/dist`, {
                shopId: item.shopId,
                stdDist: item.stdDist,
                extraCost: item.extraCost,
              });
              resolve();
            }, 100 * (index + 1));
          });
        });

        // 모든 post 요청이 완료될 때까지 기다림
        await Promise.all(postRequests);

        // 마지막에 페이지 리로드
        setTimeout(function () {
          window.location.reload();
        }, 100 * (deliveryList.length + 1));

      } else if (testResult === true && deliveryList.length === 0) {
        alert('등록할 배달비 정보를 입력해주세요.');
      }
    })

    $('.timeCostPopupBtn').off('click').on('click', function() {
      var timeCostList = []
      var modiList = []
      var removeList = []

      let hours1 = getValue("hours1");
      let minutes1 = getValue("minutes1");
      let hours2 = getValue("hours2");
      let minutes2 = getValue("minutes2");
      let timeCost = getValue("timeCost");

      if(!hours1 && !minutes1 && !hours2 && !minutes2 && !timeCost) {
        $(".timeLabel").each(function() {
          var dataId = $(this).attr('data-id');
          var dataIdx = $(this).attr('data-idx');

          var hours1 = document.getElementById("hours1").getAttribute("data-value");
          var minutes1 = document.getElementById("minutes1").getAttribute("data-value");
          var hours2 = document.getElementById("hours2").getAttribute("data-value");
          var minutes2 = document.getElementById("minutes2").getAttribute("data-value");

          var startDate = ('0' + hours1).slice(-2) + ':' + ('0' + minutes1).slice(-2)
          var endDate = ('0' + hours2).slice(-2) + ':' + ('0' + minutes2).slice(-2)

          var data = {
            id: Number(dataIdx),
            shopId: shopId,
            dowTpcd: Number(dataId),
            extraStartTm: startDate,
            extraEndTm: endDate
          }

          removeList.push(data);
        })

        removeList.forEach((item, index) => {
          setTimeout(function() {
            axios.delete(`${ BACK_OFFICE_API }/extra/time`, {
              params: {
                shopId: item.shopId,
                dowTpcd: item.dowTpcd,
                extraStartTm: item.extraStartTm,
                extraEndTm: item.extraEndTm
              }
            })

          }, 100 * (index + 1));
        });

        setTimeout(function() {
          window.location.reload()
        }, 100 * (removeList.length + 1));
      } else {
        if($('#hours1').val() === '') {
          alert('시간을 입력해주세요')
          return false
        }
        if($('#minutes1').val() === '') {
          alert('시간을 입력해주세요')
          return false
        }
        if($('#hours2').val() === '') {
          alert('시간을 입력해주세요')
          return false
        }
        if($('#minutes2').val() === '') {
          alert('시간을 입력해주세요')
          return false
        }
        if($('#timeCost').val() === '') {
          alert('배달비를 입력해주세요')
          return false
        }

        var startDate = ('0' + $('#hours1').val()).slice(-2) + ':' + ('0' + $('#minutes1').val()).slice(-2)
        var endDate = ('0' + $('#hours2').val()).slice(-2) + ':' + ('0' + $('#minutes2').val()).slice(-2)

        $('.timeLabel').each(function() {
          var dataId = $(this).attr('data-id')
          var dataType = $(this).attr('data-type')
          var dataModi = $(this).attr('data-modi')
          var dataIdx = $(this).attr('data-idx')

          if(Number(dataModi) === 1) {
            if(Number(dataType) === 1) {
              var data = {
                id: Number(dataIdx),
                dowTpcd: Number(dataId),
                extraStartTm: startDate,
                extraEndTm: endDate,
                extraCost: Number($('#timeCost').val())
              }

              modiList.push(data)
            } else {
              var data = {
                id: Number(dataIdx),
                shopId: shopId,
                dowTpcd: Number(dataId),
                extraStartTm: startDate,
                extraEndTm: endDate
              }

              removeList.push(data)
            }
          } else {
            if(Number(dataType) === 1) {
              var data = {
                shopId: shopId,
                dowTpcd: Number(dataId),
                extraStartTm: startDate,
                extraEndTm: endDate,
                extraCost: Number($('#timeCost').val())
              }
              timeCostList.push(data)
            }
          }
        })

        if(timeCostList.length === 0 && modiList.length === 0 && removeList.length === 0) {
          alert('날짜를 선택해주세요')
        } else {
          if(timeCostList.length !== 0 && modiList.length !== 0) {
            timeCostList.forEach((item, index) => {
              setTimeout(function() {
                axios.post(`${ BACK_OFFICE_API }/extra/time`, {
                  shopId: item.shopId,
                  dowTpcd: item.dowTpcd,
                  extraStartTm: item.extraStartTm,
                  extraEndTm: item.extraEndTm,
                  extraCost: item.extraCost
                })

              }, 100 * (index + 1))
            })

            modiList.forEach((item, index) => {
              setTimeout(function() {
                axios.put(`${ BACK_OFFICE_API }/extra/time/${ item.id }`, {
                  id: item.id,
                  dowTpcd: item.dowTpcd,
                  extraStartTm: item.extraStartTm,
                  extraEndTm: item.extraEndTm,
                  extraCost: item.extraCost
                })

              }, 100 * (timeCostList.length + 1))
            })

            removeList.forEach((item, index) => {
              setTimeout(function() {
                axios.delete(`${ BACK_OFFICE_API }/extra/time`, {
                  params: {
                    shopId: item.shopId,
                    dowTpcd: item.dowTpcd,
                    extraStartTm: item.extraStartTm,
                    extraEndTm: item.extraEndTm
                  }
                })

              }, 100 * (timeCostList.length + modiList.length + 1))
            })

            setTimeout(function() {
              window.location.reload()
            }, 100 * (timeCostList.length + modiList.length + removeList.length + 1))
          } else if(timeCostList.length !== 0 && modiList.length === 0) {
            $('.lodding').removeClass('hide')
            timeCostList.forEach((item, index) => {
              setTimeout(function() {
                axios.post(`${ BACK_OFFICE_API }/extra/time`, {
                  shopId: item.shopId,
                  dowTpcd: item.dowTpcd,
                  extraStartTm: item.extraStartTm,
                  extraEndTm: item.extraEndTm,
                  extraCost: item.extraCost
                })

              }, 100 * (index + 1))
            })

            setTimeout(function() {
              window.location.reload()
            }, 100 * (timeCostList.length + 1))
          } else if(timeCostList.length === 0 && modiList.length !== 0) {
            modiList.forEach((item, index) => {
              setTimeout(function() {
                axios.put(`${ BACK_OFFICE_API }/extra/time/${ item.id }`, {
                  id: item.id,
                  dowTpcd: item.dowTpcd,
                  extraStartTm: item.extraStartTm,
                  extraEndTm: item.extraEndTm,
                  extraCost: item.extraCost
                })

              }, 100 * (index + 1))
            })

            removeList.forEach((item, index) => {
              setTimeout(function() {
                axios.delete(`${ BACK_OFFICE_API }/extra/time`, {
                  params: {
                    shopId: item.shopId,
                    dowTpcd: item.dowTpcd,
                    extraStartTm: item.extraStartTm,
                    extraEndTm: item.extraEndTm
                  }
                })

              }, 100 * (modiList.length + 1))
            })

            setTimeout(function() {
              window.location.reload()
            }, 100 * (modiList.length + removeList.length + 1))
          } else if (removeList.length !== 0) {
            removeList.forEach((item, index) => {
              setTimeout(function() {
                axios.delete(`${ BACK_OFFICE_API }/extra/time`, {
                  params: {
                    shopId: item.shopId,
                    dowTpcd: item.dowTpcd,
                    extraStartTm: item.extraStartTm,
                    extraEndTm: item.extraEndTm
                  }
                })

              }, 100 * (index + 1))
            })

            setTimeout(function() {
              window.location.reload()
            }, 100 * (removeList.length + 1))
          }
        }
      }
    })

    $('.dongCostPopupBtn').off('click').on('click', async function() {
      let dongList = [];
      let modiList = [];
      let result = true;
      const cost = $('#dongCost').val();

      if (cost === '') {
        alert('배달비를 입력해주세요.');
        result = false;
        return false;
      }

      $('.dongListBox label').each(function() {
        const id = $(this).attr('data-id');
        const idx = $(this).attr('data-idx');
        const modi = $(this).attr('data-modi');
        const type = $(this).attr('data-type');

        const item = {
          id: id,
          extraCost: cost,
          shopId: shopId,
          addrMgt: idx,
          type: type,
        };

        if (Number(type) === 1) {
          if (Number(modi) === 1) {
            modiList.push(item);
          } else {
            dongList.push({
              shopId: shopId,
              addrMgt: idx,
              extraCost: cost,
            });
          }
        } else if (Number(modi) === 1) {
          modiList.push(item);
        }
      });

      // API 호출 함수 (순차 실행을 위해 async 함수 사용)
      const apiCall = async (method, url, data, index, totalLength) => {
        try {
          await new Promise(resolve => setTimeout(resolve, 100 * (index + 1 + totalLength))); // 순차 실행을 위한 딜레이
          if (method === 'post' || method === 'put') {
            await axios[method](url, data);
          } else {
            await axios.delete(url, { params: data });
          }
        } catch (error) {
          console.error('API 요청 중 오류 발생:', error);
        }
      };

      const postDongList = async () => {
        for (let index = 0; index < dongList.length; index++) {
          await apiCall('post', `${BACK_OFFICE_API}/extra/dong`, {
            shopId: dongList[index].shopId,
            addrMgt: dongList[index].addrMgt,
            extraCost: dongList[index].extraCost,
          }, index, 0);
        }
      };

      const processModiList = async () => {
        for (let index = 0; index < modiList.length; index++) {
          const method = Number(modiList[index].type) === 1 ? 'put' : 'delete';
          const url = `${BACK_OFFICE_API}/extra/dong`;
          const data = method === 'delete' ? { shopId: modiList[index].shopId, id: modiList[index].id } : { id: modiList[index].id, extraCost: modiList[index].extraCost };

          await apiCall(method, url, data, index, dongList.length);
        }
      };

      /*const deleteDeliList = async () => {
        for (let i = 0; i < propsLengthList.length; i++) {
          await axios.delete(`${ BACK_OFFICE_API }/extra/dist`, {
            params: {
              shopId: Number(propsLengthList[i].shopId),
              stdDist: propsLengthList[i].stdDist
            }
          });
        }
      };

      if (result) {
        await deleteDeliList(); // 삭제 작업 먼저 실행
      }*/

      if (result && dongList.length > 0 && modiList.length > 0) {
        $('.lodding').removeClass('hide');
        await postDongList();  // 동 리스트 API 순차 실행
        await processModiList(); // 수정 리스트 API 순차 실행
        setTimeout(() => window.location.reload(), 100);
      } else if (result && dongList.length > 0) {
        $('.lodding').removeClass('hide');
        await postDongList();  // 동 리스트만 있을 경우 실행
        setTimeout(() => window.location.reload(), 100);
      } else if (result && modiList.length > 0) {
        $('.lodding').removeClass('hide');
        await processModiList();  // 수정 리스트만 있을 경우 실행
        setTimeout(() => window.location.reload(), 100);
      }
    });


    // 행정동 불러오기
    let dongCostList3 = output1.map((value, index) => {
      var cost = value[0].extraCost
      var name = String(value[0].extraCost).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

      return (
        <li key={ index } className="selectoption" data-id={ value.addrMgtId } data-cost={ cost } data-modi='1' data-name={ name } onClick={ this.selectDong }>{ name }</li>
      )
    })

    return (
      <div>
        <div id="timeCostPopup" className='timeCostPopup popupV2 hide'>
          <div className='popupContainer width578'>
            <div className='popupTitle'>
              <h2>시간대별 추가 배달비</h2>
              <button className='closeBtn stopCloseBtn' onClick={() => closePopup("timeCostPopup")}>
                <img src={ closeV2 } alt='취소' />
              </button>
            </div>
            <div className='popupContent'>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexTitle timeInputTitle'>요일 선택</div>
              </div>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexContent'>
                  <div>
                    <label className='timeAllLabel label' data-type='0'>전체선택</label>
                    <label className='timeLabel timeLabel1 label' data-type='0' data-id='1' data-modi='0' data-idx='0'>월요일</label>
                    <label className='timeLabel timeLabel2 label' data-type='0' data-id='2' data-modi='0' data-idx='0'>화요일</label>
                    <label className='timeLabel timeLabel3 label' data-type='0' data-id='3' data-modi='0' data-idx='0'>수요일</label>
                    <label className='timeLabel timeLabel4 label' data-type='0' data-id='4' data-modi='0' data-idx='0'>목요일</label>
                    <label className='timeLabel timeLabel5 label' data-type='0' data-id='5' data-modi='0' data-idx='0'>금요일</label>
                    <label className='timeLabel timeLabel6 label' data-type='0' data-id='6' data-modi='0' data-idx='0'>토요일</label>
                    <label className='timeLabel timeLabel7 label' data-type='0' data-id='7' data-modi='0' data-idx='0'>일요일</label>
                  </div>
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexTitle timeInputTitle'>시간 설정</div>
              </div>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexContent timeCostBox'>
                  <input
                    type='number' id='hours1' className='hours' name='hours1' maxLength={2}
                    onInput={(e) => {
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' id='minutes1' className='minutes' name='minutes1' maxLength={2}
                    onInput={(e) => {
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span className='underSpan'>~</span>
                  <input
                    type='number' id='hours2' className='hours' name='hours2' maxLength={2}
                    onInput={(e) => {
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' id='minutes2' className='minutes' name='minutes2' maxLength={2}
                    onInput={(e) => {
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexTitle timeInputTitle'>추가 배달비</div>
              </div>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexContent'>
                  <input type='number' id='timeCost' className='addCost' name='timeCost' />원
                </div>
              </div>
            </div>
            <div className='popupBtn'>
              <button type='button' className='closeBtn' onClick={() => closePopup("timeCostPopup")}>취소</button>
              <button type='button' className='timeCostPopupBtn blueBtn'>확인</button>
            </div>
          </div>
        </div>

        <div id="dongCostPopup" className='dongCostPopup popupV2 hide'>
          <div className='popupContainer width540'>
            <div className='popupTitle'>
              <h2>지역별 추가 배달비</h2>
              <button className='closeBtn stopCloseBtn' onClick={() => closePopup("dongCostPopup")}>
                <img src={ closeV2 } alt='취소' />
              </button>
            </div>
            <div className='popupContent dongTextList'>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexTitle'>요금 선택</div>
                <div className='flexContent'>
                  <div id='paySelect' className='popupSelect select selectBox'>
                    <div className='paySelect selectText selectTextBox' data-href='paySelect' data-id='0' data-modi='0'>신규 추가</div>
                    <ul id="paySelectUl" className='selectOptionListBox selectOptionList'>
                      <li className="selectoption" data-id='0' data-modi='0' data-name='신규 추가' onClick={ this.selectDong }>신규 추가</li>
                      { dongCostList3 }
                    </ul>
                  </div>
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexTitle timeInputTitle'>추가 배달비</div>
              </div>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexContent'>
                  <input type='number' id='dongCost' className='addCost' name='dongCost' />원
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexTitle'>추가 가능 지역</div>
              </div>
              <div>
                <div className='flexContent'>
                  <div className='dongListBox'>
                  </div>
                </div>
              </div>
            </div>
            <div className='popupBtn'>
              <button type='button' className='closeBtn' onClick={() => closePopup("dongCostPopup")}>취소</button>
              <button type='button' className='dongCostPopupBtn blueBtn'>확인</button>
            </div>
          </div>
        </div>
      </div>
      
    )
  }
}

export { ShopInfo4PopupV2 };